import { DECommonTable } from 'components/DataExpansionComponents/Common/CommonTable/CommonTable'
import { DataTableProvider } from 'components/DataTable'
import { ContactResponse } from 'models/contacts'
import useApiService from 'services/api'
import { ColumnsStoreProvider } from 'stores/ColumnsStore/ColumnsStoreProvider'
import { dataTableSortingStoreRepo } from '../../../../DataTable/DataTableSorting/DataTableSortingStore'
import { IColumnVisibility } from '../../../../DataTable/types'
import { useLodgingDoorsTableCols } from './LodgingDoorsTableColumns'
import { FilterIdentifier } from 'models/saved_view'
import { LodgingDoorsFilterset } from './LodgingDoorsFilterset'
import LodgingDoorExportModal from 'components/Modals/ExportModal/LodgingDoorExportModal'
import { StandardSummaryResponse } from 'models/paginated-response'

type SortableFields = (keyof ContactResponse | string)[]

const sortableFields: SortableFields = [
  'note_count',
  'contact_count',
  'deal_count',
  'name',
  'address',
  'city',
  'state',
  'country',
  'phone',
  'website',
  'reviews_avg',
  'reviews_cnt',
  'chain_doors_cnt',
]

export interface LodgingTableProps {
  setTotalRowsCount?: (count: StandardSummaryResponse) => void
  pageParamName?: string
  baseFilters?: Record<string, any>
  tableKey: string
  filterIdentifierModifier?: FilterIdentifier
  hideCreateCompanyButton?: boolean
  AfterSearchComponent?: React.ReactNode
}

function LodgingDoorTableComponent(props: LodgingTableProps) {
  const api = useApiService()
  const { tableKey, ...rest } = props
  const { sorting } = dataTableSortingStoreRepo.getStore(props.tableKey)()
  const columns = useLodgingDoorsTableCols({
    sorting,
    inCampaigns: props.baseFilters?.campaigns,
  })
  return (
    <DECommonTable
      {...rest}
      tableKey={tableKey}
      columns={columns}
      sortableFields={sortableFields}
      filterIdentifier="LODGING_DOOR_TABLE"
      apiGetListAction={api.getLodgingDoorList}
      apiGetSummaryAction={api.getLodgingDoorSummary}
      companyTypeSlug="lodging-hospitality"
      tableTypeSlug="lodging-hospitality-doors"
      searchPlaceholder="Search lodging by name"
      FilterSet={LodgingDoorsFilterset}
      ExportModal={LodgingDoorExportModal}
      chainProxyIdAccessorKey="chain_proxy.id"
      doorProxyIdAccessorKey="id"
      isDoorsTable={true}
    />
  )
}

export function LodgingDoorTable(
  props: LodgingTableProps & {
    defaultColumnVisibility?: IColumnVisibility<any>
  }
) {
  const { tableKey, defaultColumnVisibility, ...rest } = props

  return (
    <ColumnsStoreProvider
      tableKey={tableKey}
      defaultColumnVisibility={{
        name: true,
        address: true,
        city: true,
        state: true,
        place_url: true,
        phone: true,
        door_taglist: true,
        door_distributors: true,
        reviews_avg: true,
        zipcode: true,
        country: false,
        reviews_cnt: false,
        website: false,
        chain_doors_cnt: false,
        deal_count: false,
        campaigns: false,
        sales_stages: false,
        account_owners: false,
        chain_proxy_taglist: false,
        note_count: false,
        chain_proxy_distributors: false,
        ...defaultColumnVisibility,
      }}
      initialColumnOrder={[
        'name',
        'address',
        'city',
        'state',
        'zipcode',
        'place_url',
        'phone',
        'door_taglist',
        'door_distributors',
        'reviews_avg',
      ]}
      savedPresetsIdentifier="LODGING_DOOR_TABLE"
      preferredGroupOrder={['Target Attributes', 'Campaigns and Deals']}
    >
      <DataTableProvider tableKey={tableKey}>
        <LodgingDoorTableComponent tableKey={tableKey} {...rest} />
      </DataTableProvider>
    </ColumnsStoreProvider>
  )
}
